export default "__VITE_ASSET__BxovJtPW__"